<template>
  <div>
    <div class="row" v-if="!is_landing_page">
      <div class="col-12">
        <h2>Map</h2>
        <hr>
      </div>
    </div>
    <div class="row" style="height: 250px" v-if="!is_landing_page">
      <div class="col-5">
        <div class="row">
          <div class="col-12">
            <label for="ddlMaps">Map:</label>
            <select class="form-control" id="ddlMaps" v-model="selected_map_id" @change="map_dropdown_change()">
              <option value="0">Select..</option>
              <option v-for="map in maps" :key="map.map_id" v-bind:value="map.map_id">{{ map.name
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="row" v-if="!is_landing_page">
          <div class="col-12">
            <label>Zone Filter:</label>
            <v-select multiple
                      v-model="zones_selected"
                      :options="zones_for_drop_down"
                      @input="loadMap()"
                      placeholder="Showing All"></v-select>
          </div>
        </div>
        <br>
        <div class="row" v-if="!is_landing_page">
          <div class="col-12">
            <button type="button" class="btn btn-success" @click="saveMap()">Save Map</button>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
      <div class="col-5" v-if="show_details">
        <div class="form-group" v-if="selected_polygon.device_id !== 0">
            <label for="txtName">Extension</label>
            <input type="text" class="form-control" id="txtName" v-model="selected_polygons_map_device.extension" disabled>
        </div>
        <div class="form-group" v-if="selected_polygon.device_id !== 0">
          Status:
          <span :class="selected_polygons_map_device.registered ? 'registered' : 'not-registered'">{{ selected_polygons_map_device.registered ? 'Registered' : 'Not Registered' }}</span>
        </div>
        <div class="form-group">
            <label for="ddlDevice">Device</label>
            <select class="form-control" id="ddlDevice" v-model="selected_polygon.device_id">
              <option value="0">Select..</option>
              <option v-for="map_device in filtered_map_devices" :key="map_device.device_id" v-bind:value="map_device.device_id">{{ map_device.name }}
              </option>
            </select>
        </div>
        <div class="form-group" v-if="selected_polygon.device_id !== 0">
          <button type="button" class="btn btn-sm btn-hub-primary" v-if="![0,9000].includes(selected_polygons_map_device.extension)"
            @click="call()">{{ 'Call ' + selected_polygons_map_device.name + ' (' + selected_polygons_map_device.extension + ') '}}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="height:890px;">
        <map-toolbar v-if="!is_landing_page" dropshadow>
          <toolbar-button toggle-draw-mode title="Toggle Draw Mode"></toolbar-button>
          <toolbar-button delete-polygon title="Delete Selected Polygon"></toolbar-button>
        </map-toolbar>
        <map-container style="width:1600px; height:800px;" dropshadow></map-container>
      </div>
    </div>
    <div class="row" v-if="selected_map_id !== '0'">
      <div class="col-12">
        <label>Zone Key:</label>
          <ul class="list-group list-group-horizontal">
            <li v-for="zone in filtered_zones" :key="zone.zone_id" :style="{ 'background-color': zone.color + '80' }" class="list-group-item">
              {{ zone.name }}
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import '../../assets/css/map.css'
import { Map } from '../../assets/js/map.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import _ from 'lodash'

export default {
  props: {
    is_landing_page: {
      type: Boolean,
      default: false
    },
    default_map_id: {
      type: Number
    }
  },
  components: { vSelect },
  data: function () {
    return { 
      map: {},
      polygons: [],
      selected_polygon: {},
      selected_map_id: '0',
      zones_selected: []
    }
  },
  computed: {
    ...mapGetters({
      db_polygons: 'allPolygons',
      logged_in_user: 'loggedInUser',
      maps: 'siteMaps',
      map_devices: 'allMapDevices',
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones',
      zones_for_drop_down: 'allZonesForDropdown'
    }),
    filtered_map_devices: function () {
      return this.map_devices.filter(map_device => map_device.site_id === this.scoped_site_id)
    },
    filtered_zones: function () {
      return this.zones.filter(zone => zone.site_id === this.scoped_site_id)
    },
    selected_polygons_map_device: function () {
      return this.map_devices.filter(map_device => map_device.device_id === this.selected_polygon.device_id)[0]
    },
    show_details: function () {
      return !(_.isEmpty(this.selected_polygon))
    }
  },
  mounted () {
    this.initDropDown()
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getMapDevices')
    this.$store.dispatch('getZones')
    this.$store.dispatch('getMaps')
  },
  sockets: {
    event: function (data) {
      console.log(data)
      let matched_polygons = this.polygons.filter(function (polygon) {
        return polygon.device_id.toString() === data.device_id.toString()
      })
      let self = this
      if (!_.isEmpty(matched_polygons)) {
        $('polygon').each(function (index, item) {
          for (let i = 0; i < matched_polygons.length; i++) {
            let polygon = matched_polygons[i]
            if (item.id === polygon.id) {
              if (data.type === 'call_answered') {
                self.map.activateAlarmForPolygon(item);
              } else {
                self.map.deactivateAlarmForPolygon(item);
              }
              break
            }
          }
        })
      }
    }
  },
  methods: {
    initDropDown () {
      let self = this
      setTimeout(function () {
        if (self.is_landing_page) {
          self.selected_map_id = self.default_map_id
          self.map_dropdown_change()
        }
        // load zone filter
        if (self.zones_for_drop_down.length === 0) {
          for (let i = 0; i < self.zones.length; i++) {
            if (self.zones[i].site_id === self.scoped_site_id) {
              self.zones_for_drop_down.push({
                value: self.zones[i].zone_id,
                label: self.zones[i].name
              })
            }
          }
        }
      }, 1000)
    },
    map_dropdown_change () {
      this.initMap()
    },
    initMap () {
      let self = this

      let containerElement = document.querySelector(Map.MAP_CONTAINER)
      if (containerElement === null)
          throw `Missing Element Exception - "${Map.MAP_CONTAINER}"`

      // Initialize the map
      self.map = new Map(containerElement, [2,3,4].includes(this.logged_in_user.group_id), function (selectedPolygon) {
        let p_index = -1;

        // Find the polygons index in the components polygon list
        for (let i = 0; i < self.polygons.length; i++) {
          if (self.polygons[i].id === selectedPolygon.id) {
            p_index = i;
            break
          }
        }

        // If it couldn't be found, then add it
        if (p_index === -1) {
          self.polygons.push({
            id: selectedPolygon.id,
            device_id: 0
          })

          self.selected_polygon = self.polygons[self.polygons.length - 1]
        } else {
          self.selected_polygon = self.polygons[p_index]
        }
      })

      // Toolbar event handlers
      if (!self.is_landing_page) {
        let toggleDrawMode = document.querySelector('toolbar-button[toggle-draw-mode]')
        let deletePolygon = document.querySelector('toolbar-button[delete-polygon]')
        toggleDrawMode.addEventListener('click', function (event) {
          if ([2,3,4].includes(self.logged_in_user.group_id)) {
            let isToggledOn = event.target.hasAttribute('toggle-state-on')
            isToggledOn ? event.target.removeAttribute('toggle-state-on') : event.target.setAttribute('toggle-state-on', '')
            isToggledOn = !isToggledOn
            self.map.setDrawMode(isToggledOn)
          } else {
            alert('You need to be an admin to toggle draw mode.')
          }
        })
        deletePolygon.addEventListener('click', function (event) {
          if ([2,3,4].includes(self.logged_in_user.group_id)) {
            $("polygon").each(function (index, item) {
              // Match them with the polygon objects in the data
              if (item.id === self.selected_polygon.id) {
                item.remove()
                $('div[polygon-id="' + self.selected_polygon.id + '"][class^="handlebar"]').remove()
                self.selected_polygon = {}
              }
            })
          } else {
            alert('You need to be an admin to delete.')
          }
        })
      }

      // Load a map image
      self.map.load('./upload/images/' + self.selected_map_id + '.png')
      // self.map.load('./' + self.selected_map_id + '.png')

      self.loadMap()
    },
    loadMap () {
      let self = this

      // disable map change
      $('#ddlMaps').prop('disabled', true);

      // clear map
      self.polygons = []
      self.selected_polygon = {}
      $('polygon').remove()
      $('.handlebar').remove()

      this.$store.dispatch('getPolygons', self.selected_map_id).then(function () {
        // Load from db
        for (let i = 0; i < self.db_polygons.length; i++) {
          let db_polygon = self.db_polygons[i]

          if (db_polygon.map_id !== self.selected_map_id) {
            continue
          }

          let map_device = self.filtered_map_devices.filter(map_device => map_device.device_id === db_polygon.device_id)[0]
          
          if (self.zones_selected.length > 0) {
            // Check to see if any of the selected zones are associated with the polygons map_device
            let include = false

            for (let j = 0; j < self.zones_selected.length; j++) {
              for (let k = 0; k < map_device.zones.length; k++) {
                if (map_device.zones[k].zone_id === self.zones_selected[j].value) {
                  include = true
                  break
                }
              }
            }
            
            // If not, do not draw to map
            if (!include) {
              continue
            }
          }

          // Draw to map and push data to component polygons list
          self.map.drawPolygon(db_polygon.polygon_id, map_device.color, db_polygon.points, map_device.registered)
          self.polygons.push({ id: db_polygon.polygon_id.toString(), device_id: db_polygon.device_id })
        }
      })
      
    },
    saveMap () {
      let self = this
      let polygonsToSave = []

      // Get all the polygon objects from the html
      $("polygon").each(function (index, item) {
        if (item.attributes.points) {
          let polygonToSave = {
            polygon_id: (!item.id.includes('polygon_') ? parseInt(item.id) : 0),
            map_id: parseInt(self.selected_map_id),
            device_id: 0,
            points: item.attributes.points.nodeValue
          }

          let match = false

          // Match them with the polygon objects in this component
          for (let i = 0; i < self.polygons.length; i++) {
            if (self.polygons[i].id === item.id &&
                self.polygons[i].device_id !== 0) {
              polygonToSave.device_id = self.polygons[i].device_id
              match = true
            }
          }

          if (match) {
            polygonsToSave.push(polygonToSave)
          }
        }
      })
      
      // Ship them off for saving
      self.$store.dispatch('saveMap', { polygons: polygonsToSave, map_id: self.selected_map_id })
    },
    call () {
      this.$store.dispatch('executeCommand', 'start_intercom_call ' + this.scoped_site_id + ' ' + this.selected_polygons_map_device.extension)
    }

  }
}

</script>

<style scoped>
.registered {
  color: green;
}

.not-registered {
  color: red;
}
</style>
